export default "__VITE_ASSET__086de8a6__"